export default "__VITE_PUBLIC_ASSET__dac407e4__"